import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { selectProjects } from 'core/userContext/selectors';
import { getClonedFromJourney } from 'modules/workflows/ducks';

const StyledWarningBanner = styled(WarningBanner)`
  margin-bottom: ${spacing.threeQuarter};
`;

export const CLONE_ERROR_BANNER_ID = 'clone-error-banner';

export const CloneErrorBanner = () => {
  const clonedFromJourney = useSelector(getClonedFromJourney);
  const projects = useSelector(selectProjects) || [];
  const clonedFromProjectId = clonedFromJourney?.projectId;
  const project = projects.find((p) => p.id === clonedFromProjectId);

  if (!project) return null;
  return (
    <StyledWarningBanner
      title={`Some copied fields could not be matched from the original project, "${project?.name}"`}
      data-test={CLONE_ERROR_BANNER_ID}
    >
      Please update the missing dependencies to refer to this project&apos;s data and resources
    </StyledWarningBanner>
  );
};
